/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ValidationError } from '../model/validation-error.model';
import { MessageFactory, MessageFactoryProvider } from '../provider/message-factory.provider';
import { TextService } from '../service/text.service';

export class ComparatorValidationErrorMessageFactory implements MessageFactory {

  constructor(private textService: TextService) { }

  getMessage(error: ValidationError): string {
    const messageKey = error.validationKey;
    const messageArgs: { [key: string]: any } = Object.assign({}, error.validationArguments);
    const options = error.validationArguments.options;
    if (typeof options === 'object') {
      if (options.key !== undefined) {
        const scope = error.validationArguments.scope;
        messageArgs.other = scope ? `#(${scope}/${options.key})` : options.key;
      } else if (options.value !== undefined) {
        messageArgs.other = options.value;
      }
    } else if (typeof options === 'string') {
      const scope = error.validationArguments.scope;
      messageArgs.other = scope ? `#(${scope}/${options})` : options;
    } else {
      messageArgs.other = options;
    }
    return this.textService.getText(messageKey, messageArgs);
  }
}
